import React, { useCallback } from 'react'

import { Dropdown, Flex, Tooltip } from '@sketch/components'
import {
  useSortingSettings,
  SortBy,
  SortOrder,
} from 'modules/shares/hooks/useSortSettings'

import { ArrowDownIcon, ArrowUpIcon } from './SortDropdown.styles'

interface DropdownItemProps {
  label: string
  itemSortBy: SortBy
}

const MAP_SORT_ORDER_TO_LABEL: Record<SortBy, Record<SortOrder, string>> = {
  'created-at': {
    asc: 'Show Older First',
    desc: 'Show Newer First',
  },
  'last-modified': {
    asc: 'Show Older First',
    desc: 'Show Newer First',
  },
  name: {
    asc: 'Order by A-Z',
    desc: 'Order by Z-A',
  },
}

const DropdownItem: React.FC<DropdownItemProps> = ({ label, itemSortBy }) => {
  const { sortBy, sortOrder, setSortBy, setSortOrder } = useSortingSettings()
  const selected = sortBy === itemSortBy
  const handleClick = useCallback(() => {
    if (selected) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
    } else {
      setSortBy(itemSortBy)
    }
  }, [selected, setSortOrder, sortOrder, itemSortBy, setSortBy])

  return (
    <Dropdown.Item className={selected ? 'active' : ''} onClick={handleClick}>
      <Flex justifyContent="space-between">
        <div>{label}</div>
        <Tooltip
          content={MAP_SORT_ORDER_TO_LABEL[sortBy][sortOrder]}
          placement="top"
        >
          {selected && sortOrder === 'asc' && <ArrowUpIcon />}
          {selected && sortOrder === 'desc' && <ArrowDownIcon />}
        </Tooltip>
      </Flex>
    </Dropdown.Item>
  )
}

export const SortDropdown = () => {
  return (
    <>
      <Dropdown.Header>Sort By</Dropdown.Header>
      <DropdownItem label="Name" itemSortBy="name" />
      <DropdownItem label="Date created" itemSortBy="created-at" />
      <DropdownItem label="Last updated" itemSortBy="last-modified" />
    </>
  )
}
